import Model from './../Model'

export default class Reminder extends Model
{
    static updateController = new AbortController();
    static async create(id, data) {
        return await Http.post(route('api.v2.organization.user.reminder.create', id), data)
    }

    static async delete(id) {
        return await Http.delete(route('api.v2.organization.user.reminder.delete', id))
    }

    static async update(id, data) {
        this.updateController.abort()
        this.updateController = new AbortController();
        await Http.send('put', route('api.v2.organization.user.reminder.update', id), data, {
            signal: this.updateController.signal
        }).catch(err => {
        })
    }

    static async markDone(id) {
        this.updateController.abort()
        this.updateController = new AbortController();
        await Http.send('put', route('api.v2.organization.user.reminder.done', id), {}, {
            signal: this.updateController.signal
        }).catch(err => {
        })
    }

    static async markTodo(id) {
        this.updateController.abort()
        this.updateController = new AbortController();
        await Http.send('put', route('api.v2.organization.user.reminder.todo', id), {}, {
            signal: this.updateController.signal
        }).catch(err => {
        })
    }

}
